/* BLACK NOVEMBER EXCLUSIVE: the free gifts stay only while the offer still has a keyboard AND a mouse in the cart. */
(function () {
  var OFFER = 'black-november-setup';
  var busy = false;

  function isGift(i) { return !!(i.properties && i.properties['FREE GIFT']); }

  function orphanGifts(cart) {
    var gifts = cart.items.filter(function (i) { return isGift(i) && i.properties._offer === OFFER; });
    if (!gifts.length) return [];
    var roles = {};
    cart.items.forEach(function (i) {
      var p = i.properties || {};
      if (!isGift(i) && p._offer === OFFER && p._ft_role) roles[p._ft_role] = (roles[p._ft_role] || 0) + i.quantity;
    });
    return roles.kb && roles.mouse ? [] : gifts;
  }

  async function run() {
    if (busy) return;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var bad = orphanGifts(cart);
      if (!bad.length) return;
      for (var k = 0; k < bad.length; k++) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: bad[k].key, quantity: 0 }) });
      }
      var fresh = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: fresh } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: fresh } }));
      if (/^\/cart/.test(location.pathname)) location.reload();
    } catch (e) {
    } finally {
      busy = false;
    }
  }

  document.documentElement.addEventListener('cart:change', function () { setTimeout(run, 700); });
  window.addEventListener('load', function () { setTimeout(run, 1200); });
})();
